export default __webpack_public_path__ + "034fed2.png";